import { useForm } from 'react-hook-form';
import { FormProvider, TextField } from '../../../../../components';
import { Button, Grid, Stack, Typography, Box,IconButton } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import * as Yup from 'yup';

export const InfertilityTreatement = ({ onAdd, onClose, setInfertilityTreatmentDialog }) => {
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
      
      })
    ),
    mode: 'all',
  });
  const { handleSubmit, reset } = methods;

  const formSubmit = (formValue) => {
    onAdd(formValue);
    setInfertilityTreatmentDialog(false);
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
    <Stack direction="row" spacing={0} alignItems="center" justifyContent="space-between" sx={{ marginBottom:2,borderBottom: 1, borderColor: 'grey.300', paddingBottom: 2 }}>
        <Typography variant="h4" fontWeight="bold" sx={{marginBottom:"2%"}}>
          Infertility Treatement
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>
      <Grid container spacing={3}>

        {/* Left Side */}
        <Grid item xs={12} >
          <Stack spacing={2}>
            <Stack spacing={1} direction="row" alignItems="center">
              <Typography sx={{ width: '120px', fontWeight: 600, fontSize: '1.2rem' }}>Laproscopy</Typography>
              <TextField fullWidth variant="outlined" name="laproscopy" placeholder="Laproscopy" />
            </Stack>

            <Stack spacing={1} direction="row" alignItems="center">
              <Typography sx={{ width: '120px', fontWeight: 600, fontSize: '1.2rem' }}>Hystroscopic</Typography>
              <TextField fullWidth variant="outlined" name="hystroscopic" placeholder="Hystroscopic" />
            </Stack>

            <Stack spacing={1} direction="row" alignItems="center">
              <Typography sx={{ width: '120px', fontWeight: 600, fontSize: '1.2rem' }}>HSG</Typography>
              <TextField fullWidth variant="outlined" name="hsg" placeholder="HSG" />
            </Stack>
            <Stack spacing={1} direction="row" alignItems="center">
              <Typography sx={{ width: '120px', fontWeight: 600, fontSize: '1.2rem' }}>Medical Treatement</Typography>
              <TextField fullWidth variant="outlined" name="medical_treatement" placeholder="Medical Treatement" />
            </Stack>

            <Stack spacing={1} direction="row" alignItems="center">
              <Typography sx={{ width: '120px', fontWeight: 600, fontSize: '1.2rem' }}>IUI</Typography>
              <TextField fullWidth variant="outlined" name="iui" placeholder="IUI" />
            </Stack>
            <Stack spacing={1} direction="row" alignItems="center">
              <Typography sx={{ width: '120px', fontWeight: 600, fontSize: '1.2rem' }}>IVF/CSI</Typography>
              <TextField fullWidth variant="outlined" name="ivf_csi" placeholder="IVF/CSI" />
            </Stack>
          </Stack>
        </Grid>
      </Grid>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 3 }}>
        <Button variant="contained" type="submit" sx={{ marginRight: 2 }}>
          Add
        </Button>
        <Button color="error" onClick={onClose}>
          Close
        </Button>
      </Box>
    </FormProvider>
  );
};
